<template>
  <form-item-wrapper :designer="designer" :field="field" :rules="rules" :design-state="designState"
    :parent-widget="parentWidget" :parent-list="parentList" :index-of-parent-list="indexOfParentList"
    :sub-form-row-index="subFormRowIndex" :sub-form-col-index="subFormColIndex" :sub-form-row-id="subFormRowId">
    <div class="picker mResult">
      <van-field :label="field.options.label" :disabled="field.options.disabled" :required="field.options.required" readonly clickable :value="selectedValue"
        :placeholder="field.options.placeholder" @click="show" :input-align="field.options.textAlign" />
      <van-popup v-model="showPicker" round position="bottom">
        <van-picker ref="picker" show-toolbar :columns="field.options.optionItems" :title="field.options.title"
          value-key="label" :defaultIndex="defaultIndex" @cancel="showPicker = false" @confirm="onConfirm">
          <div slot="columns-bottom" class="close" @click="showPicker = false">
            关闭
          </div>
        </van-picker>
      </van-popup>
    </div>
  </form-item-wrapper>
</template>

<script>
import FormItemWrapper from "@/components/form-designer/form-widget/field-widget/form-item-wrapper";
import emitter from "@/utils/emitter";
import i18n, { translate } from "@/utils/i18n";
import fieldMixin from "@/components/form-designer/form-widget/field-widget/fieldMixin";
import { isNull } from "@/utils/util";

export default {
  name: "pickerWidget",
  componentName: "FieldWidget", //必须固定为FieldWidget，用于接收父级组件的broadcast事件
  mixins: [emitter, fieldMixin, i18n],
  inject: ["refList", "globalOptionData", "globalModel"],
  props: {
    field: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number,
    designer: Object,

    designState: {
      type: Boolean,
      default: false,
    },

    subFormRowIndex: {
      /* 子表单组件行索引，从0开始计数 */ type: Number,
      default: -1,
    },
    subFormColIndex: {
      /* 子表单组件列索引，从0开始计数 */ type: Number,
      default: -1,
    },
    subFormRowId: {
      /* 子表单组件行Id，唯一id且不可变 */ type: String,
      default: "",
    },
  },
  data() {
    return {
      selectedValue: "",
      showPicker: false,
      defaultIndex: 0,
      fieldModel: "",
      rules: [],
    };
  },
  components: {
    FormItemWrapper,
  },

  created() {
    /* 注意：子组件mounted在父组件created之后、父组件mounted之前触发，故子组件mounted需要用到的prop
         需要在父组件created中初始化！！ */
    this.registerToRefList();
    this.initOptionItems()
    this.initEventHandler();

    this.handleOnCreated();

    // this.buildFieldRules();
    this.syncUpdateFormModel("");
    this.buildFieldRules();
    if (this.field.options.required) {
      this.rulesF();
    }
    if(this.field.options.defaultValue1){
      this.fieldModel=this.field.options.defaultValue1
    }
  },
  watch: {
    fieldModel(key) {
      this.field.options.optionItems.forEach((e, index) => {
        if (e.value == key) {
          this.defaultIndex = index
          this.selectedValue = e.label
        }
      });
    }
  },

  mounted() {
    this.handleOnMounted();
  },

  beforeDestroy() {
    this.unregisterFromRefList();
  },

  methods: {
    show(){
      this.showPicker =!this.field.options.disabled
    },
    onConfirm(value) {
      this.fieldModel = value[this.field.options.valueKey] || value.value;
      this.selectedValue =value[this.field.options.labelKey]|| value.label;
      this.dispatch("ElFormItem", "el.form.change", [this.fieldModel]);
      this.handleChangeEvent(this.fieldModel);
      this.handleBlurCustomEvent(this.fieldModel);
      this.showPicker = false
    },
    setColumns(data) {
      this.field.options.optionItems = data
    },

    rulesF() {
      let _this = this;
      this.rules.push({
        validator: function (rule, value, callback, errorMsg) {
          if (isNull(value)) {
            _this.aa()

            callback(new Error(
              _this.aa()
            ));
            return;
          }
          callback();
        },
        trigger: ["blur", "change"],
        label: this.field.options.label,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/vant.scss";

.area-input {
  height: 36px;
  border: 1px solid #ccc;
  padding-left: 10px;
}


.close {
  text-align: center;
  border-top: 1px solid #DCDFE6;
}
</style>
